exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtitle[data-v-bc0461fe] {\n  color: #757575;\n  padding-top: 20px !important;\n  text-align: left !important;\n}", ""]);

// exports
